import { render, staticRenderFns } from "./EditWidget.vue?vue&type=template&id=3e15600c&scoped=true"
import script from "./EditWidget.vue?vue&type=script&lang=js"
export * from "./EditWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e15600c",
  null
  
)

export default component.exports